module.exports = __webpack_public_path__ + "img/BGR.b834d724.svg";